// extracted by mini-css-extract-plugin
module.exports = {"webcam":"Room_webcam__3Zj24","sidebarActions":"Room_sidebarActions__2hGby","stickyBottom":"Room_stickyBottom__2yWZg","messageList":"Room_messageList__2Wolp"};